/**
 * ギフトボックス提案セクション（カートページ用）
 *
 * - バリアント選択変更時に価格を動的更新
 * - 「追加」ボタン押下で /cart/add.js にAjaxリクエスト
 * - 追加成功後、カートセクションを再取得して更新
 */
(function () {
  'use strict';

  const giftbox_section = document.getElementById('cm-cart-giftbox');
  if (!giftbox_section) return;

  /**
   * バリアント変更時に価格を更新
   */
  function setupVariantChange() {
    const current_giftbox = document.getElementById('cm-cart-giftbox');
    if (!current_giftbox) return;

    const select_elements = current_giftbox.querySelectorAll('select.cm-cart-giftbox__select');
    select_elements.forEach(function (select_el) {
      // 既存のリスナーを二重登録しない工夫は、親要素ごと再描画されているなら問題なし
      select_el.addEventListener('change', function () {
        const selected_option = select_el.options[select_el.selectedIndex];
        if (!selected_option) return;

        const price_formatted = selected_option.dataset.priceFormatted;
        const item_el = select_el.closest('.cm-cart-giftbox__item');
        if (!item_el) return;

        /* 価格を更新 */
        const price_el = item_el.querySelector('.cm-cart-giftbox__price');
        if (price_el && price_formatted) {
          const currency_text = price_el.querySelector('.currency-code');
          const tax_text = price_el.querySelector('.tax-included');
          price_el.innerHTML = price_formatted + currency_text.outerHTML + tax_text.outerHTML;
        }

        /* バリアント画像を更新 */
        const image_el = item_el.querySelector('.cm-cart-giftbox__variant-image');
        if (image_el) {
          const variant_image_url = selected_option.dataset.image;
          const variant_image_alt = selected_option.dataset.imageAlt;
          if (variant_image_url) {
            image_el.src = variant_image_url;
            image_el.alt = variant_image_alt || '';
          } else {
            /* バリアント画像がない場合はデフォルト画像に戻す */
            const default_image = image_el.dataset.defaultImage;
            const default_alt = image_el.dataset.defaultAlt;
            if (default_image) {
              image_el.src = default_image;
              image_el.alt = default_alt || '';
            }
          }
        }
      });
    });
  }

  /**
   * 「追加」ボタン: Ajaxでカートに追加
   */
  function setupAddButtons() {
    const current_giftbox = document.getElementById('cm-cart-giftbox');
    if (!current_giftbox) return;

    const add_buttons = current_giftbox.querySelectorAll('.cm-cart-giftbox__add-btn');

    add_buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        const item_el = btn.closest('.cm-cart-giftbox__item');
        if (!item_el) return;

        const select_el = item_el.querySelector('.cm-cart-giftbox__select');
        if (!select_el) return;

        const variant_id = select_el.value;
        if (!variant_id) return;

        /* ボタンをローディング状態にする */
        const original_text = btn.textContent;
        btn.textContent = '追加中...';
        btn.classList.add('cm-cart-giftbox__add-btn--loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variant_id, 10), quantity: 1 }]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('カート追加エラー: ' + response.status);
            }
            return response.json();
          })
          .then(function () {
            /* 成功時: カートセクションを更新（ボタン状態はセクション再描画で制御） */
            refreshCartSections();

            /* カートアイコンのバブルを更新 */
            updateCartBubble();
          })
          .catch(function (error) {
            console.error('ギフトボックス追加エラー:', error);
            alert('カートへの追加に失敗しました。もう一度お試しください。');
            /* エラー時のみボタン状態を復元 */
            btn.textContent = original_text;
            btn.classList.remove('cm-cart-giftbox__add-btn--loading');
            btn.disabled = false;
          });
      });
    });
  }

  /**
   * カートセクションを再取得して更新
   */
  function refreshCartSections() {
    const items_el = document.getElementById('main-cart-items');
    const footer_el = document.getElementById('main-cart-footer');
    
    const items_section_id = items_el ? items_el.dataset.id : 'main-cart-items';
    const footer_section_id = footer_el ? footer_el.dataset.id : 'main-cart-footer';

    const sections_to_update = [items_section_id, footer_section_id];
    const sections_param = sections_to_update.join(',');

    fetch('/?sections=' + sections_param)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        /* カートアイテムセクションを更新 */
        if (data[items_section_id]) {
          const cart_items_el = document.getElementById('main-cart-items');
          if (cart_items_el) {
            const temp = document.createElement('div');
            temp.innerHTML = data[items_section_id];
            const new_content = temp.querySelector('#main-cart-items');
            if (new_content) {
              cart_items_el.innerHTML = new_content.innerHTML;
            }
          }
        }

        /* カートフッターセクションを部分更新 */
        if (data[footer_section_id]) {
          const temp = document.createElement('div');
          temp.innerHTML = data[footer_section_id];

          /* 小計・割引・合計エリア（.js-contents）を更新 */
          const current_js_contents = document.querySelector('#main-cart-footer .js-contents');
          const new_js_contents = temp.querySelector('.js-contents');
          if (current_js_contents && new_js_contents) {
            current_js_contents.innerHTML = new_js_contents.innerHTML;
          }

          /* 購入制限警告エリアを更新 */
          const current_warnings = document.querySelector('[data-purchase-limit-warnings]');
          const new_warnings = temp.querySelector('[data-purchase-limit-warnings]');
          if (current_warnings && new_warnings) {
            current_warnings.innerHTML = new_warnings.innerHTML;
            current_warnings.className = new_warnings.className;
          }

          /* ギフトボックスラッパーを更新 */
          const current_giftbox_wrapper = document.querySelector('.cm-cart-giftbox-wrapper');
          const new_giftbox_wrapper = temp.querySelector('.cm-cart-giftbox-wrapper');
          if (current_giftbox_wrapper && new_giftbox_wrapper) {
            current_giftbox_wrapper.innerHTML = new_giftbox_wrapper.innerHTML;
            /* 新しいDOMに対してイベントを再設定 */
            setupVariantChange();
            setupAddButtons();
          }
        }
      })
      .catch(function (error) {
        console.error('カートセクション更新エラー:', error);
      });
  }

  /**
   * ギフトボックスラッパーのみを再取得して更新
   * カートから商品が削除された際に呼び出し、ボタン状態を同期する
   */
  function refreshGiftboxWrapper() {
    const footer_el = document.getElementById('main-cart-footer');
    const footer_section_id = footer_el ? footer_el.dataset.id : 'main-cart-footer';

    fetch('/?sections=' + footer_section_id)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data[footer_section_id]) return;

        const temp = document.createElement('div');
        temp.innerHTML = data[footer_section_id];

        const current_giftbox_wrapper = document.querySelector('.cm-cart-giftbox-wrapper');
        const new_giftbox_wrapper = temp.querySelector('.cm-cart-giftbox-wrapper');
        if (current_giftbox_wrapper && new_giftbox_wrapper) {
          current_giftbox_wrapper.innerHTML = new_giftbox_wrapper.innerHTML;
          setupVariantChange();
          setupAddButtons();
        }
      })
      .catch(function (error) {
        console.error('ギフトボックスセクション更新エラー:', error);
      });
  }

  /**
   * カートアイコンのバブル（個数表示）を更新
   */
  function updateCartBubble() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart_data) {
        const bubble_elements = document.querySelectorAll('.cart-count-bubble span');
        bubble_elements.forEach(function (el) {
          el.textContent = cart_data.item_count;
        });

        /* カートアイコンバブルが非表示の場合に表示する */
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(function (bubble) {
          if (cart_data.item_count > 0) {
            bubble.removeAttribute('hidden');
          }
        });
      })
      .catch(function (error) {
        console.error('カートバブル更新エラー:', error);
      });
  }

  /* --- 初期化 --- */
  setupVariantChange();
  setupAddButtons();

  /* カート更新（商品削除・数量変更等）を検知してギフトボックスの状態を同期 */
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      refreshGiftboxWrapper();
    });
  }
})();
